import React, { useEffect } from 'react';

import axios from 'axios';
import _ from 'lodash';
import { connect, useSelector } from 'react-redux';

import './TablePage.css';
import { APPLICATION_HEADERS, API_URLS } from '../../models/headers';
import {
  calcCostPerSeat,
  scrollClickHandler,
  getUniqueListBy,
  changeDateFormat,
} from '../../utils/utils';

const TablePage = (props) => {
  const isPdfContent = useSelector((state) => state.comRed.pdfDownload);

  const { data } = props;
  const options = isPdfContent
    ? _.orderBy(data?.optionProviderRequestList, 'shortlistedOrder', 'asc')
    : _.orderBy(data?.optionProviderRequestList, 'optionOrder', 'asc');

  const currentDeal = useSelector((state) => state.comRed.currentDeal);

  const modifiedDates = [];
  let finalDate;

  useEffect(() => {
    props.setDate(finalDate);
  }, [finalDate, props]);

  const date_sort_desc = function (date1, date2) {
    if (date1 > date2) return -1;
    if (date1 < date2) return 1;

    return 0;
  };

  if (options) {
    options.map((option) => {
      if (option?.modifiedDate) {
        modifiedDates.push(option?.modifiedDate);
      }
    });

    modifiedDates.sort(date_sort_desc);

    if (modifiedDates && modifiedDates.length > 0) {
      finalDate = modifiedDates[0]?.split(' ')?.[0]; // The first date in the sorted array
    }
  }

  const calcCapacity = (availableSpaces) => {
    let capacity = 0;

    if (availableSpaces && availableSpaces.length > 0) {
      availableSpaces.map((as) => {
        if (as) {
          capacity += as.capacity;
        }
      });
    }

    return capacity;
  };

  const formatDate1 = (availableSpaces) => {
    if (availableSpaces && availableSpaces.length > 0) {
      if (availableSpaces[0] && availableSpaces[0].dateAvailable) {
        const inputDate = availableSpaces[0].dateAvailable;

        if (new Date() >= new Date(inputDate)) {
          return 'Now';
        }

        return changeDateFormat(inputDate);
      }

      return '-';
    }

    return '-';
  };

  const formatNum = (num) => {
    if (num) {
      const formatted = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

      return formatted;
    }

    return '-';
  };

  const getAddress = (option) => {
    if (option.address && option.address.address) {
      return option.address.address;
    }
    if (option.availableSpaces && option.availableSpaces.length > 0) {
      if (option.availableSpaces[0].unified_location) {
        return option.availableSpaces[0].unified_location.address;
      }
    }
  };

  const getID = (option) => {
    if (option.ID) {
      return option.ID;
    }
    if (option.availableSpaces && option.availableSpaces[0].ID) {
      return option.availableSpaces[0].ID;
    }
  };
  const getOptionID = (option) => {
    if (option.id) {
      return option.id;
    }
    if (option.availableSpaceList && option.availableSpaceList[0].optionId) {
      return option.availableSpaceList[0].optionId;
    }
  };

  const updateBubbleOption = (url, obj, headers, id) => {
    axios
      .put(url, obj, { headers })
      .then((res) => {
        if (res && res.status === 200) {
          //successs call
          console.log('success');
          document.getElementById('row_' + id).classList.remove('responded');
        } else {
          //    failure call
          console.log('failure');
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          console.log(error);
        } else {
          updateBubbleOption(url, obj, headers, id);
        }
      });
  };

  const updateLatestResponse = (id) => {
    const optionURL = API_URLS.updateBubbleOptionURL;

    const latestObj = {
      id: id,
      isLatestResponse: 'no',
    };

    const listLatestObj = { list: [latestObj] };

    updateBubbleOption(optionURL, listLatestObj, APPLICATION_HEADERS.dealHeaders, id);
  };

  const getProvider = (option) => {
    if (option?.providerName) {
      return option.providerName;
    }
    if (
      option.availableSpaceList &&
      option.availableSpaceList.length > 0 &&
      option.availableSpaceList[0] &&
      option.availableSpaceList[0].provider
    ) {
      return option.availableSpaceList[0].provider;
    }
  };

  const clickHandler = (row) => {
    updateLatestResponse(getOptionID(row));
    scrollClickHandler(getOptionID(row));
  };

  return (
    <div className="test">
      {/* eslint-disable-next-line */}
      <h1 align="left" style={{ padding: '30px', fontSize: '34px', color: '#1A1A1A' }}>
        <span className="targetMarket">
          {currentDeal && currentDeal['Target Market'] && currentDeal['Target Market']}
        </span>{' '}
        Agile Options
      </h1>
      <div
        className="table-view-container"
        style={{ background: '#E5E5E5', margin: '20px', height: '30vh' }}
      >
        <div className="table-container">
          <table style={{ height: '70vh' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', width: '4%' }}>S.No</th>
                <th style={{ textAlign: 'left', width: '20%' }}>Provider</th>
                <th style={{ textAlign: 'left', width: '25%' }}>Address</th>
                <th style={{ textAlign: 'right', width: '9%' }}>Desk Count</th>
                <th style={{ textAlign: 'right', width: '12%' }}>Date Available</th>
                <th style={{ textAlign: 'right', width: '15%' }}>Cost/Seat/Month</th>
                <th style={{ textAlign: 'right', width: '15%' }}>Total Cost</th>
              </tr>
            </thead>
            <tbody>
              {options &&
                options.map((row, i) => (
                  <tr
                    id={`row_${row.id}`}
                    title="View Option Details"
                    style={{ cursor: 'pointer' }}
                    key={row.id}
                    onClick={() => clickHandler(row)}
                  >
                    <td style={{ textAlign: 'left', width: '4%' }}>{i + 1} </td>
                    <td style={{ textAlign: 'left', width: '20%' }}>
                      {getProvider(row) ? getProvider(row) : '-'}{' '}
                    </td>
                    <td style={{ textAlign: 'left', width: '25%' }}>
                      <div>{getAddress(row) ? getAddress(row) : '-'}</div>
                    </td>
                    <td style={{ textAlign: 'right', width: '9%' }}>
                      {calcCapacity(row.availableSpaceList)}
                    </td>
                    <td style={{ textAlign: 'right', width: '12%' }}>
                      {formatDate1(row.availableSpaceList)}
                    </td>
                    <td style={{ textAlign: 'right', width: '15%' }}>
                      {calcCostPerSeat(row)[0] !== 0 && calcCostPerSeat(row)[0] !== 'NaN'
                        ? calcCostPerSeat(row)[0]
                        : '-'}
                    </td>
                    <td style={{ textAlign: 'right', width: '15%' }}>
                      {calcCostPerSeat(row)[1] !== 0 ? calcCostPerSeat(row)[1] : '-'}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.optRed.data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setDate: (date) => dispatch({ type: 'SET_DATE', date }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TablePage);
